import { useEffect } from "react";

export default function ClearStorageOnClose() {
  useEffect(() => {
    const clearStorage = () => {
      localStorage.removeItem("TTS");
    };

    window.addEventListener("beforeunload", clearStorage);

    return () => {
      window.removeEventListener("beforeunload", clearStorage);
    };
  }, []);

  return null;
}
